import React from 'react';
import { getLeadGenTotalInvestment, getPracticeLeadGenTotalInvestment } from 'api/financials';

const globalData: Partial<Record<'my' | 'practice', number>> = {};

const useLeadGenerationInvestment = (
    timeRangeMonths?: number,
    isPractice = false,
): [number | undefined, boolean, () => void] => {
    const scope = isPractice ? 'practice' : 'my';
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<number | undefined>(globalData[scope]);
    const fetchData = async () => {
        try {
            setLoading(true);
            const request = isPractice ? getPracticeLeadGenTotalInvestment : getLeadGenTotalInvestment;
            const result = await request(timeRangeMonths || 0);
            if (!result.error) {
                const data: number = result?.data?.data;
                globalData[scope] = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (timeRangeMonths !== undefined) {
            fetchData();
        }
    }, [timeRangeMonths, isPractice]);

    return [items, loading, fetchData];
};

export default useLeadGenerationInvestment;
